module.exports = __webpack_public_path__ + "static/media/circle-check-fade.073a6ce0.svg";